export default [
    {
        path: 'relatorio-estatistico-atendimento',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-estatistico-atendimento' */
            '@/views/atencao-basica/relatorio-estatistico-atendimento/Index'
        ),
        redirect: 'relatorio-estatistico-atendimento/index',
        children: [
            {
                name: 'atencao-basica-relatorio-estatistico-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-estatistico-atendimento' */
                    '@/views/atencao-basica/relatorio-estatistico-atendimento/List.vue'
                ),
            },
        ],
    },
]
